const SmallGridIcon = ( ) => {
	return (
		<div className={ 'qec-grid-icon qec-grid-icon--small' }>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
		</div>
	);
};

export default SmallGridIcon;
